import { createSlice } from '@reduxjs/toolkit';
import { getBehaviorsUsersBehaviors } from 'src/api/backstage/security/behaviors';
import { createAppAsyncThunk } from 'src/hooks/hooks';
import { Behaviors, EnumBehaviorKey } from 'src/types/Behaviors';

export interface BehaviorState {
  behaviors: Behaviors.DataItem[];
  behaviorKeys: EnumBehaviorKey[];
}

export const getBehaviors = createAppAsyncThunk(
  'behavior/getBehaviors',
  async (data, { getState }) => {
    const state = getState();
    if (!state.user?.userId) {
      return Promise.reject();
    }
    const {
      json: { result },
    } = await getBehaviorsUsersBehaviors();
    return result;
  },
);

const initialState: BehaviorState = {
  behaviors: [],
  behaviorKeys: [],
};

const behaviorSlice = createSlice({
  name: 'behavior',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getBehaviors.fulfilled, (state, action) => {
      state.behaviors = action.payload.behaviors || [];
      state.behaviorKeys = state.behaviors.map(v => v.key);
    });
    builder.addCase(getBehaviors.rejected, state => {
      state.behaviors = [];
      state.behaviorKeys = [];
    });
  },
});

export default behaviorSlice.reducer;
